



















































import { filterMixin } from '@/utils/mixins/filterMixin'
import Autocomplete from '@/components/Autocomplete.vue'
import { getRegions, getSubregions } from '@/api/Address/address'
import { Params } from '@/utils/interfaces'
import { getAgencies } from '@/api/Agency/agency.api'
import FlatFilter from '~/components/FlatFilter.vue'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'

export default filterMixin.extend({
  components: {
    appAutocomplete: Autocomplete,
    FlatFilter,
  },
  data() {
    return {
      searchTerms: [this.$t('name')],
      getRegions: (params?: Params) =>
        getRegions({ ...params, country__name: 'Cuba' }),
      getSubregions: (params?: Params) =>
        getSubregions({ ...params, country__name: 'Cuba' }),
      getAgencies: getAgencies,
      currencies: Object.keys(DeliveryCurrenciesEnum),
    }
  },
  methods: {
    newFilter() {
      const search = this.filter.search
      const numberValue = parseInt(search)
      const filter = { ...this.filter } as { [key: string]: any }
      if (numberValue) {
        filter.search = numberValue
      }
      this.$emit('filter', filter)
    },
  },
})
